const firebaseConfig = {
    apiKey: "AIzaSyA-Rw3nh8wBIoSwhqh_NUjecUUsHgIKc5s",
    authDomain: "travelbee-80ebc.firebaseapp.com",
    projectId: "travelbee-80ebc",
    storageBucket: "travelbee-80ebc.appspot.com",
    messagingSenderId: "190002966704",
    appId: "1:190002966704:web:b27cd7342c627be7404b75"
  };
  export default firebaseConfig;